import { ParagraphHelperService } from './paragraph.helper.service';

export const helpers: any[] = [ParagraphHelperService];

export * from './paragraph.helper.service';
